import { createContext, useContext, useState, useCallback, useMemo } from "react";

const SimCtx = createContext(null);
const KEY = "mctech_sim";
const emptyPerms = { can_create_assistants: false, can_download_csv: false, can_view_history: false, adv_stats: false, white_label: false, qr_tickets: false };

export function SimulationProvider({ children }) {
  const [sim, setSim] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
  });

  const persist = (s) => {
    setSim(s);
    if (s) sessionStorage.setItem(KEY, JSON.stringify(s));
    else sessionStorage.removeItem(KEY);
  };

  const startSim = useCallback((u) => {
    persist({
      user_id: u.user_id,
      name: u.name || u.email,
      email: u.email,
      plan: u.plan || "free",
      custom_perms: u.custom_perms || { ...emptyPerms },
    });
  }, []);

  const stopSim = useCallback(() => persist(null), []);

  const updatePerms = useCallback((patch) => {
    setSim((prev) => {
      if (!prev) return prev;
      const next = { ...prev, plan: "custom", custom_perms: { ...prev.custom_perms, ...patch } };
      sessionStorage.setItem(KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const value = useMemo(() => ({ sim, startSim, stopSim, updatePerms }), [sim, startSim, stopSim, updatePerms]);
  return <SimCtx.Provider value={value}>{children}</SimCtx.Provider>;
}

export const useSimulation = () => useContext(SimCtx) || { sim: null };
